// extracted by mini-css-extract-plugin
module.exports = {"navigationItem":"NavigationItem_navigationItem__3Ljla","active":"NavigationItem_active__3UhZp"};